"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateUnique = exports.createKey = void 0;
var _changeCase = require("change-case");
var _uuid = require("uuid");
var createKey = function createKey() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  return params.filter(function (param) {
    return !!param;
  }).map(function (param) {
    return (0, _changeCase.paramCase)(param + '');
  }).join('-');
};
exports.createKey = createKey;
var generateUnique = function generateUnique() {
  return "c".concat((0, _uuid.v4)().replace(/[^\d\w]/gm, ''));
};
exports.generateUnique = generateUnique;